// extracted by mini-css-extract-plugin
module.exports = {"root":"SideMenu_root__2fPds"};